import { defineStore } from 'pinia';
import { markRaw } from 'vue';
import PbsDeleteModalContent, { PbsDeleteModalOptions } from '../components/PbsDeleteModalContent.vue';
import PbsConfirmModalContent, { PbsConfirmModalOptions } from '../components/PbsConfirmModalContent.vue';

export interface IModalContent {
    props?: Object;
    component: Object;
    title: string;
    closable?: boolean;
    modLarge?: boolean;
}

export interface ModalStoreState {
    content: IModalContent | undefined | null;
    open: boolean;
}

export const useModalStore = defineStore('modal-store', {
    state: (): ModalStoreState => ({
        content: null,
        open: false
    }),
    getters: {},
    actions: {
        showModal(content: IModalContent) {
            if (content) {
                this.content = {
                    component: markRaw(content.component),
                    title: content.title || '',
                    props: content.props,
                    closable: content.closable !== undefined ? content.closable : true,
                    modLarge: content.modLarge !== undefined ? content.modLarge : false
                };
                this.open = true;
            }
        },
        showDeleteModal(options: { title: string; props: PbsDeleteModalOptions }) {
            this.showModal({
                component: PbsDeleteModalContent,
                title: options.title,
                props: options.props
            });
        },
        showConfirmModal(options: { title: string; props: PbsConfirmModalOptions }) {
            this.showModal({
                component: PbsConfirmModalContent,
                title: options.title,
                props: options.props
            });
        },
        hideModal() {
            this.open = false;
            this.content = null;
        }
    }
});
